module.exports = __webpack_public_path__ + "static/media/rsahi.6dbd5e8e.png";